export default "__VITE_ASSET__DIWrj8hZ__"